import ImageViewer from '../../ImageViewer';

import { ImageTitle, ItemWrapper } from './styles';

const ViewsAndLayoutsListItem = ({ image }) => {
  return (
    <ItemWrapper>
      <ImageViewer
        imageId={image.imageId}
        containerStyle={{
          width: '50%',
          height: '245px',
        }}
      />
      <ImageTitle>{image.legend}</ImageTitle>
    </ItemWrapper>
  );
};

export default ViewsAndLayoutsListItem;
